<template>
	<div :class="'input-item checkbox-item ' + classList + ' ' + containerClasses" :style="styles">
		<div class="input-field-block checkbox-field-block">
			<label class="input-label" :for="id" v-if="labelAbove !== ''">{{ labelAbove }}</label>
			<label class="input-label checkbox-label" :for="id" style="user-select: none">
				<span v-if="label !== '' && labelBefore && !isHtml">{{ label }}</span>
				<span v-if="label !== '' && labelBefore && isHtml">{{ label }}</span>
				<input
					@change="update($event)"
					@click="clickHandler($event)"
					:type="type"
					:id="id"
					:name="name"
					:value="inputValue"
					:checked="checked"
					:placeholder="placeholder"
					:style="inputStyles"
					:class="'checkbox ' + classList + ' ' + extraClasses"
					:tabindex="tabindex"
					:autofocus="autofocus"
					:disabled="disabled"
					:required="required"
					ref="input"
				/>
				<span v-if="label !== '' && !labelBefore && !isHtml" :style="labelStyle">{{ label }}</span>
				<span v-html="label" v-if="label !== '' && !labelBefore && isHtml" :style="labelStyle"></span>
				<span v-if="asterisk" style="color: #ff4666">*</span>
				<icon type="help" class="not-mobile help-icon-for-field" v-if="help !== ''" :tooltip="help"></icon>
			</label>
		</div>
		<p class="input-help error" v-if="error" v-html="error"></p>
		<p class="input-help only-mobile" v-if="help !== ''" v-html="help"></p>
		<p class="input-help" v-if="extraHelp !== ''" v-html="extraHelp"></p>
	</div>
</template>

<script type="text/babel">
export default {
	props: {
		id: { default: "" },
		name: { default: "" },
		checkedValue: { default: 1 },
		value: { default: false },
		placeholder: { default: "" },

		label: { default: "" },
		labelAbove: { default: "" },
		help: { default: "" },

		error: { default: false },
		required: { default: false },
		asterisk: { default: false },
		disabled: { default: false },
		autofocus: { default: false },
		labelBefore: { default: false },
		paddingTop: { default: true },
    marginTop: { default: true },

		hasError: { default: false },
		hasSuccess: { default: false },
		isLoading: { default: false },
		noLabel: { default: false },
		isFull: { default: false },
		block: { default: false },

		type: { default: "checkbox" }, // Checkbox or Radio
		extraClasses: { default: "" },
		containerClasses: { default: "" },
		width: { default: null },
		tabindex: { default: null },
		size: { default: "regular" }, // regular, large
		labelStyle: { default: null },
		extraHelp: { default: "" },
		isHtml: { default: false }, // Whether to parse label as HTML or not
	},

	data: function () {
		return {
			generatedInputStyles: [],
		};
	},

	watch: {
		value: function (value) {
			if (value === "true") {
				this.value = true;
			}

			if (value === "false") {
				this.value = false;
			}
		},
	},

	methods: {
		clickHandler(event) {
			event.stopPropagation();
		},

		update(e) {
			if (this.type === "radio") {
				this.$emit("input", e.target.value);
			} else {
				this.$emit("input", e.target.checked);
			}

			this.$emit("change", e);
		},
	},

	computed: {
		inputValue: {
			get: function () {
				return this.checkedValue;
			},

			set: function () {
				this.$emit("input", this.checkedValue);
			},
		},

		checked() {
			let checked = false;

			if (this.type === "radio") {
				checked = this.value === this.checkedValue;
			} else if (this.type === "checkbox") {
				checked = typeof this.value === "boolean" ? this.value : false;
			}

			return checked;
		},

		styles() {
			let style = {};

			if (this.width !== null) {
				style["width"] = this.width;
			}

			return style;
		},

		inputStyles() {
			let style = {};

			this.generatedInputStyles.forEach(function (item) {
				style[item.type] = item.value;
			});

			return style;
		},

		classList() {
			let classList = "";

			classList += " size-" + this.size;
			classList += " type-" + this.type;

			if (this.label !== "" && !this.noLabel) {
				classList += " has-label";
			} else {
				classList += " no-label";
			}

			if (this.help !== "") {
				classList += " has-help";
			}

			if (this.labelAbove !== "" || !this.paddingTop) {
				classList += " has-label-above";
			}

			if (this.labelBefore) {
				classList += " label-before";
			}

			if (this.hasSuccess) {
				classList += " has-success";
			}

			if (this.hasError || this.error) {
				classList += " has-error";
			}

			if (this.isLoading) {
				classList += " is-loading";
			}

			if (this.isFull) {
				classList += " is-full";
			}

			if (this.required) {
				classList += " is-required";
			}

			return classList;
		},
	},
};
</script>
